/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Overview_Downgrade_ScheduledInputs */



/**
* | output |
* | --- |
* | "Downgrade scheduled" |
*
* @param {Sub_Overview_Downgrade_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_downgrade_scheduled = /** @type {((inputs?: Sub_Overview_Downgrade_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Downgrade_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade geplant")
	return /** @type {LocalizedString} */ ("Downgrade scheduled")
});